import axiosInstance from '../../config/AxiosConfig'
import {BACKEND_ENDPOINT} from '../../Constants'

const ADDITIONAL_INFO_PATH = 'additionalInfo'

//#region Create Or Update
export function createOrUpdateAdditionalInfo(userId, data) {
    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/${ADDITIONAL_INFO_PATH}/createOrUpdate`,
            data,
            {
                params: {
                    userId,
                },
            },
        )
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
//#endregion
